import { createAllServices } from "@ecommerce/http-services";
import { userStorage } from "../utils/storage";
import { useCartStore } from "@ecommerce/cart";
import { httpClient } from "./client";

const httpServices = createAllServices(httpClient);
const baseOrderService = httpServices.orders;

const withPricingContext = <T>(
    payload: T,
): T & {
    contextoPrecio: string | null;
} => ({
    ...(payload as T),
    contextoPrecio: useCartStore.getState().lastPricingContext,
});

export const HttpProduct = httpServices.products;
export const HttpCategory = httpServices.categories;
export const HttpOrder = {
    ...baseOrderService,
    createOrder: <TCreate = any, TResponse = any>(order: TCreate) =>
        baseOrderService.createOrder<TCreate, TResponse>(withPricingContext(order)),
    updateOrder: <TUpdate = any, TResponse = any>(orderGuid: string, order: TUpdate) =>
        baseOrderService.updateOrder<TUpdate, TResponse>(orderGuid, withPricingContext(order)),
    completeCheckout: <TFinish = any, TResponse = any>(orderGuid: string, order: TFinish) =>
        baseOrderService.completeCheckout<TFinish, TResponse>(orderGuid, withPricingContext(order)),
    calculate: <TCalculation = any, TResponse = any>(order: TCalculation) =>
        baseOrderService.calculate<TCalculation, TResponse>(withPricingContext(order)),
};

export const isPricingContextChangedError = (error: unknown): boolean => {
    const cause = (error as any)?.cause;
    return (
        cause?.response?.status === 409 &&
        cause?.response?.data?.codigo === "PRECIO_CONTEXTO_CAMBIO"
    );
};
export const HttpAuth = httpServices.auth;
export const HttpUserClient = httpServices.userClients;
export const HttpUserAddress = httpServices.userAddresses;
export const HttpShippings = httpServices.shippings;
export const HttpCoupon = httpServices.coupons;
export const HttpPaymentOption = httpServices.payments;
export const HttpBanner = httpServices.banners;
export const HttpTiendaInfo = httpServices.tiendaInfo;
export const HttpPoliticaPrivacidad = httpServices.politicaPrivacidad;
export const HttpSiteSubscriptionStatus = httpServices.siteSubscriptionStatus;
export const HttpCart = httpServices.cart;

export const clearStorefrontAuthSession = () => {
    userStorage.clear();
    httpClient.setAccessToken(null);
};

export const logoutStorefrontSession = httpServices.auth.logout;

export { httpClient, restoreStorefrontSession } from "./client";
export { HttpCategoryProduct } from "./httpCategoryProduct";
export { HttpCache } from "./httpCache";
export { HttpMercadoPagoReturn } from "./httpMercadoPagoReturn";
export { HttpSecurityObjects } from "./httpSecurityObjects";
export { HttpLogger } from "./httpLogger";

export { httpClient as HttpAxiosRequest } from "./client";
export { HttpShopEstilos } from "./httpShopEstilos";
export { HttpCamposAdicionales } from "./httpCamposAdicionales";
export { HttpAfip } from "./httpAfip";
export type { AfipConstanciaVista } from "./httpAfip";
export { HttpVodaActualizacionDatos } from "./httpVodaActualizacionDatos";
